const messageCutter = (message, lengthMessage = 150, insertDots = true) => {
  return (
    message.slice(0, lengthMessage) +
    (message.length > lengthMessage && insertDots ? "..." : "")
  );
};

export default messageCutter;
